import { useContext, useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
} from "../../../node_modules/react-router-dom/dist/index";
import Dropzone from "../../components/Dropzone";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { Context } from "../../components/Context";
import moment from "../../../node_modules/moment/moment";
import DatePicker from "react-date-picker";
import Select from "react-select";
import {
  CREATE_CLASSIFIED_ADS,
  GET_ALL_STATE_BY_COUNTY_ID,
  GET_ALL_SUB_CAT_BY_CAT_ID,
  GET_CITY_BY_STATE_ID,
  GET_SUB_CAT_BY_CAT_ID,
  USER_PROFILE,
  fetchData,
} from "../../components/Service";
import { PhoneNumberUtil } from "google-libphonenumber";
import {
  PhoneInput,
  defaultCountries,
  parseCountry,
} from "react-international-phone";
import "react-international-phone/style.css";
import { scrollTop } from "../../components/Helper";

// const phoneUtil = PhoneNumberUtil.getInstance();

const noOfBedrooms = [
  { name: "0", id: "0" },
  { name: "1", id: "1" },
  { name: "2", id: "2" },
  { name: "3", id: "3" },
  { name: "4", id: "4" },
  { name: "5", id: "5" },
  { name: "6", id: "6" },
];

const noOfBathrooms = [
  { name: "0", id: "0" },
  { name: "1", id: "1" },
  { name: "2", id: "2" },
  { name: "3", id: "3" },
  { name: "4", id: "4" },
  { name: "5", id: "5" },
  { name: "6", id: "6" },
];

const noOfOtherrooms = [
  { name: "0", id: "0" },
  { name: "1", id: "1" },
  { name: "2", id: "2" },
  { name: "3", id: "3" },
  { name: "4", id: "4" },
  { name: "5", id: "5" },
  { name: "6", id: "6" },
];

const employmentType = [
  { name: "Full Time", id: "1" },
  { name: "Part Time", id: "2" },
];

const genderType = [
  { name: "Dosen't Matter", id: "1" },
  { name: "Male Only", id: "2" },
  { name: "Female Only", id: "3" },
];

const actionTypeOption = [
  { id: 1, name: "Buying" },
  { id: 2, name: "Selling" },
  { id: 3, name: "Renting" },
];

const conditionOption = [
  { id: 1, name: "new" },
  { id: 2, name: "almost new" },
  { id: 3, name: "excellent" },
  { id: 4, name: "fair" },
  { id: 5, name: "used" },
  { id: 6, name: "salvage" },
  { id: 7, name: "wrecked" },
];

const transmissionOption = [
  { id: 1, name: "Automatic" },
  { id: 2, name: "Manual" },
];

const cylinderOption = [
  { id: 1, name: "v4" },
  { id: 2, name: "v6" },
  { id: 3, name: "v8" },
  { id: 4, name: "v10" },
  { id: 5, name: "v12" },
  { id: 6, name: "other" },
];

const autoOption = [
  { id: 1, name: "sedan" },
  { id: 2, name: "crossover" },
  { id: 3, name: "suv" },
  { id: 4, name: "mini" },
  { id: 5, name: "van" },
  { id: 6, name: "truck" },
  { id: 7, name: "convertible" },
  { id: 8, name: "commercial_vehicle" },
];

const driveOption = [
  { id: 1, name: "awd" },
  { id: 2, name: "4_X_4" },
  { id: 3, name: "fwd" },
  { id: 4, name: "rwd" },
];

const currencyOption = [
  { id: 1, name: "US Dollar (USD)" },
  { id: 2, name: "Euro (EUR)" },
  { id: 3, name: "British Pound (GBP)" },
  { id: 4, name: "Japanese Yen (JPY)" },
  { id: 5, name: "Canadian Dollar (CAD)" },
  { id: 6, name: "Australian Dollar (AUD)" },
  { id: 7, name: "Swiss Franc (CHF)" },
  { id: 8, name: "Chinese Yuan (CNY)" },
  { id: 9, name: "Indian Rupee (INR)" },
  { id: 10, name: "Brazilian Real (BRL)" },
];

const years = [];

for (let year = new Date().getFullYear(); year >= 1955; year--) {
  years.push({ name: year });
}

const MPGOption = [];
for (let MPG = 11; MPG <= 40; MPG++) {
  const text = MPG === 11 ? " or below" : MPG === 40 ? " or above" : "";
  MPGOption.push({ name: `${MPG}${text}`, id: MPG });
}

const CreateAds = () => {
  const { ads_id, ads_type } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [file, setFile] = useState("");
  const [context] = useContext(Context);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [useMap, setUseMap] = useState(false);
  const [subCatList, setSubCatList] = useState([]);
  const [subSubCatList, setSubSubCatList] = useState([]);
  const [orderId, setOrderId] = useState(null);
  const [showPaypal, setShowPaypal] = useState(false);
  const [nextOpenDate, setNextOpenDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selSt, setSelSt] = useState(null);
  const [selCt, setSelCt] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [defaultPhoneCountry] = useState("us");
  const [fullPhone, setFullPhone] = useState("");

  const countriesList =
    context?.countryList?.map((item) => item?.code?.toLowerCase()) || [];

  const countries = defaultCountries.filter((country) => {
    const { iso2 } = parseCountry(country);
    return countriesList.includes(iso2);
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    setValue,
    trigger,
  } = useForm({ mode: "onChange" });

  const isPhoneValid = (phone, country_code) => {
    try {
      // if (!phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))) {
      // 	setError("contact_number", { message: "Contact number is invalid." });
      // 	setValue("contact_number", "");
      // } else {
      // 	clearErrors("contact_number");
      // 	setValue("contact_number", phone);
      // }

      const onlyPhone = phone.replace(`+${country_code}`, "").trim();
      if (onlyPhone) {
        setValue("contact_number", phone, { shouldValidate: true });
        clearErrors("contact_number");
      } else {
        setValue("contact_number", "");
        // setError("contact_number", { message: "Contact number is required." });
      }
    } catch (error) {
      return false;
    }
  };

  const getAllStateByCountryId = (country_id) => {
    let value = {
      country_id: country_id,
    };

    fetchData(
      GET_ALL_STATE_BY_COUNTY_ID,
      "POST",
      value,
      false,
      false,
      (res) => {
        if (res.status) {
          setStateList(res?.data);
        } else {
          setStateList([]);
        }
      }
    );
  };
  const getAllCityByStateAndCountryId = (state_id, refress, cityId) => {
    let value = {
      state_id: [state_id],
    };

    fetchData(GET_CITY_BY_STATE_ID, "POST", value, false, false, (res) => {
      if (res.status) {
        setCityList(res?.data);
        if (refress) {
          console.log(cityId);
          setValue("city_id", cityId);
          setSelCt({
            value: cityId * 1,
            label: res?.data?.find((item) => item?.id === cityId * 1)?.name,
          });
        }
      } else {
        setCityList([]);
      }
    });
  };
  const getAllSubCategory = () => {
    let payload = {
      category_id: ads_id,
    };

    fetchData(
      GET_ALL_SUB_CAT_BY_CAT_ID,
      "POST",
      payload,
      false,
      false,
      (res) => {
        if (res.status) {
          setSubCatList(res?.data);
        } else {
          setSubCatList([]);
        }
      }
    );
  };

  const getAllSubSubCategory = () => {
    let payload = {
      category_id: ads_id,
    };

    fetchData(GET_SUB_CAT_BY_CAT_ID, "POST", payload, false, false, (res) => {
      if (res.status) {
        setSubSubCatList(res?.data);
      } else {
        setSubSubCatList([]);
      }
    });
  };

  const onFileDrop = (file, type) => {
    setFile(file);
  };

  const onSubmit = (data, paymentData = {}) => {
    const formData = new FormData();
    let otherDetails = [];

    formData.append("user_id", context?.user?.user_id);
    formData.append("category_id", ads_id);
    formData.append("city_id", data?.city_id? data?.city_id : "");
    formData.append("state_id", data?.state_id ? data?.state_id : "");
    formData.append("country_id", data?.country_id ? data?.country_id : "");
    formData.append("title", data?.title);
    formData.append("contact_number", data?.contact_number ? data?.contact_number : "");
    formData.append("contact_name", data?.contact_name);
    formData.append("contact_email", data?.contact_email);
    formData.append("contact_address", data?.contact_address);
    formData.append("end_at", data?.end_at ? moment(data?.end_at).format("YYYY/MM/DD"):"");
    formData.append("url", data?.url);
    formData.append("message", data?.description);
    formData.append("use_address_map", useMap ? "1" : "0");
    formData.append("sub_cat_id", data?.sub_cat_id ? data?.sub_cat_id : "");

    formData.append("show_email", 0);
    formData.append("price", data?.price ? data?.price : 0);

    if (file && file.name) {
      formData.append("image", file, file?.name);
    }

    if (ads_id == 5) {
      otherDetails = [
        { Built_Year: data?.Built_Year },
        { Property_Price: data?.Property_Price },
        { Square_Feet: data?.Square_Feet },
        { No_of_Bedrooms: data?.No_of_Bedrooms },
        { No_of_Bathrooms: data?.No_of_Bathrooms },
        { No_of_Other_Rooms: data?.No_of_Other_Rooms },
        { Next_open_house_date: data?.Next_open_house_date },
      ];
    } else if (ads_id == 8) {
      otherDetails = [
        { Employment_Type: data?.Employment_Type },
        { Job_Reference_Id: data?.Job_Reference_Id },
      ];
    } else if (ads_id == 9) {
      otherDetails = [{ Gender_Preference: data?.Gender_Preference }];
    } else if (ads_id == 1) {
      otherDetails = [
        { Make: data?.Make },
        { Color: data?.Color },
        { Model: data?.Models },
        { ActionType: data?.action_type },
        { Condition: data?.Condition },
        { Transmission: data?.Transmission },
        { Cylinder: data?.cylinder },
        { DriveTrain: data?.DriveTrain },
        { Year: data?.Year },
        { VinNumber: data?.VinNumber },
        { ODOMeterReading: data?.ODO_Meter_Reading },
        { MPG: data?.MPG },
        { Type: data?.Type },
        { Currency: data?.currency },
      ];
    }

    formData.append("other_details", JSON.stringify(otherDetails));

    if (ads_type === "premium") {
      formData.append("payment_status", paymentData?.orderID ? "Approved" : "Pending");
      formData.append("order_id", paymentData?.orderID || "");
      formData.append("payer_id", paymentData?.payerID || "");
      formData.append("payment_source", paymentData?.paymentSource || "");
      formData.append("payment_id", paymentData?.paymentID || "");
      formData.append("facilitator_access_token", paymentData?.facilitatorAccessToken || "");
    }
    fetchData(CREATE_CLASSIFIED_ADS, "POST", formData, true, true, (res) => {
      if (res.status) {
        toast.success("Ad created successfully and sent for admin approval. You will be notified once it becomes active");
        navigate(`/profile?tab=ads`);
      } else {
        toast.error(res.message);
      }
    });
  };

  const checkIfFormValid = async () => {
    const isValid = await trigger();

    if (isValid) {
      setShowPaypal(true);
    } else {
      setShowPaypal(false);
    }
  };

  const createOrder = async (data, actions) => {
    console.log(data)
    const order = {
      intent: "capture",
      purchase_units: [
        {
          amount: {
            currency: "USD",
            value: 5,
          },
        },
      ],
    };

    let createdOrder = await actions.order.create(order);
    console.log("printtttttttttttttttttt",order)
    setOrderId(createdOrder);
    return createdOrder;
  };

  const onApprove = async (data, actions) => {
    console.log("printssssssssssssssssss",data, actions)
    const paymentData = {
      facilitatorAccessToken: data.facilitatorAccessToken,
      orderID: data.orderID,
      payerID: data.payerID,
      paymentID: data.paymentID,
      paymentSource: data.paymentSource,
    };
    handleSubmit((formData) => onSubmit(formData, paymentData))();
  };



  const onError = async (data, actions) => {
    toast.error(
      "Unable to create premium classified ad. Please try again later."
    );
  };

  useEffect(() => {
    if (ads_id == 1) {
      getAllSubSubCategory();
    } else {
      getAllSubCategory();
    }
  }, [ads_id]);
  console.log(context?.user);
  useEffect(() => {
    console.log(context?.user?.country_id);
    scrollTop();
    setValue("contact_email", context?.user?.email ?? "");
    setValue("contact_address", context?.user?.address ?? "");
    setValue("contact_name", context?.user?.name ?? "");
    setValue("contact_number", context?.user?.mobile ?? "");
    setFullPhone(context?.user?.mobile ?? "");

    // setValue("country_id", context.user?.country_id);
    // setSelectedCountry({
    //   value: context.user?.country_id,
    //   label: context?.countryList?.find(
    //     (item) => item?.id === context.user?.country_id
    //   )?.name,
    // });
    // getAllStateByCountryId(context.user?.country_id);
    // setValue("state_id", context.user?.state_id);
    // setSelSt({
    //   value: context.user?.state_id,
    //   label: context?.stateList?.find(
    //     (item) => item?.id === context.user?.state_id
    //   )?.name,
    // });
    // getAllCityByStateAndCountryId(context.user?.state_id, true);

    const getDetails = () => {
      let payload = {
        user_id: context?.user?.user_id,
      };

      fetchData(USER_PROFILE, "POST", payload, true, false, (res) => {
        if (res.status) {
          setValue("country_id", context.user?.country_id);
          setSelectedCountry({
            value: context.user?.country_id,
            label: context?.countryList?.find(
              (item) => item?.id === context.user?.country_id
            )?.name,
          });
          getAllStateByCountryId(context.user?.country_id);
          setValue("state_id", res?.data?.state_id.id);
          setSelSt({
            value: res?.data?.state_id.id,
            label: context?.stateList?.find(
              (item) => item?.id === res?.data?.state_id.id
            )?.name,
          });
          getAllCityByStateAndCountryId(
            res?.data?.state_id.id,
            true,
            res?.data?.city.id
          );
        }
      });
    };
    getDetails();
  }, [context?.user]);
  return (
    <>
      {context?.userToken ? (
        <div class="col-lg-12">
          <div class="card card-forum ">
            <div class="card-header usa-bg px-1">
              <div className="national-bg">
                <h4 class="text-white py-1 ind1">
                  {location?.state?.pageTitle ?? "Classifieds Ads"}
                </h4>
              </div>
            </div>

            <div class="card-body bg-white px-1">
              <form
                className="needs-validation"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-6 mb-2">
                    <label>
                      Title <span className="text-danger">*</span>
                    </label>
                    <input
                      className={`form-control bg-transparent ${
                        errors.title && "is-invalid"
                      }`}
                      placeholder="Title"
                      maxLength={60}
                      {...register("title", {
                        required: {
                          value: true,
                          message: "Title is required.",
                        },
                        minLength: {
                          value: 3,
                          message: "Title must be at least 3 characters.",
                        },
                      })}
                    />
                    {errors.title && (
                      <div class="invalid-feedback">{errors.title.message}</div>
                    )}
                  </div>

                  {ads_id != 1 && (
                    <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                      <label>
                        {ads_id == 5
                          ? "Property type"
                          : ads_id == 8
                          ? "Select Job Category"
                          : ads_id == 9 || ads_id == 10
                          ? "Type"
                          : "Select Ads Category"}
                      </label>
                      <span className="text-danger">*</span>
                      <Select
                        {...register("sub_cat_id", {
                          required: {
                            value: true,
                            message:
                              ads_id == 5
                                ? "Property type is required."
                                : "Ads category is required.",
                          },
                        })}
                        options={subCatList?.map((item) => ({
                          label: item.name,
                          value: item.id,
                        }))}
                        onChange={(selected) => {
                          setValue(
                            "sub_cat_id",
                            selected ? selected.value : ""
                          );
                          trigger("sub_cat_id");
                        }}
                        placeholder={
                          ads_id == 5
                            ? "Property type is required."
                            : "Ads category is required."
                        }
                        className={`selectpicker p-0 ${
                          errors.sub_cat_id && "is-invalid bdr-red"
                        }`}
                        classNamePrefix="react-select"
                      />
                      {errors.sub_cat_id && (
                        <div class="invalid-feedback d-block">
                          {errors.sub_cat_id.message}
                        </div>
                      )}
                    </div>
                  )}
                  <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
                    <label>
                      Ad Expiry Date <span className="text-danger">*</span>
                    </label>
                    <div className="custom-datepicker-wrapper">
                      <DatePicker
                        className={`form-control bg-transparent dp ${
                          errors.end_at && "is-invalid"
                        }`}
                        clearIcon={false}
                        monthPlaceholder="MM"
                        dayPlaceholder="DD"
                        yearPlaceholder="YYYY"
                        onChange={(date) => {
                          setEndDate(date);
                          setValue("end_at", date, { shouldValidate: true });
                        }}
                        minDate={new Date()}
                        maxDate={
                          new Date(
                            new Date().setDate(new Date().getDate() + 30)
                          )
                        }
                        value={endDate}
                      />
                    </div>
                    <input
                      type="hidden"
                      {...register("end_at", {
                        required: "Ad expiry date is required.",
                      })}
                    />
                    {errors.end_at && (
                      <div class="invalid-feedback d-block">
                        {errors.end_at.message}
                      </div>
                    )}
                  </div>
                  <div className="ccol-sm-6 col-md-4 col-lg-3 mb-2">
                    <label>
                      Contact Name
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      className={`form-control bg-transparent ${
                        errors.contact_name && "is-invalid"
                      }`}
                      placeholder="Contact Name"
                      maxLength={50}
                      {...register("contact_name", {
                        required: {
                          value: true,
                          message: "Contact name is required.",
                        },
                        pattern: {
                          value: /^[A-Za-z ]+$/,
                          message: "Only alphabetic characters are allowed.",
                        },
                      })}
                      readOnly 
                    />
                    {errors.contact_name && (
                      <div class="invalid-feedback">
                        {errors.contact_name.message}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                    <label>
                      Contact Email
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      className={`form-control bg-transparent ${
                        errors.contact_email && "is-invalid"
                      }`}
                      placeholder="Contact Email"
                      type="contact_email"
                      maxLength={120}
                      {...register("contact_email", {
                        required: {
                          value: true,
                          message: "Contact email is required.",
                        },
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                          message: "Email is invalid.",
                        },
                      })}
                      readOnly 
                    />
                    {errors.contact_email && (
                      <div class="invalid-feedback">
                        {errors.contact_email.message}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                    <label>
                      Mobile Number
                      {/* <span className="text-danger">*</span> */}
                    </label>

                    <PhoneInput
                      key={defaultPhoneCountry}
                      defaultCountry={defaultPhoneCountry}
                      countries={countries}
                      forceDialCode={true}
                      value={fullPhone}
                      hideDropdown={false}
                      disableCountryGuess={true}
                      onChange={(phone, country) => {
                        isPhoneValid(phone, country.country.dialCode);
                        setFullPhone(phone);
                      }}
                      className={`form-control bg-transparent p-0 ${
                        errors.contact_number ? "is-invalid" : ""
                      }`}
                    />
                    <input
                      type="hidden"
                      {...register("contact_number", {
                        // required: "Mobile number is required.",
                      })}
                    />
                    {errors.contact_number && (
                      <div class="invalid-feedback">
                        {errors.contact_number.message}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                    <label>Contact Address</label>
                    <input
                      class={`form-control ${
                        errors.contact_address && "is-invalid"
                      }`}
                      rows="5"
                      maxLength={1024}
                      placeholder="Contact Address"
                      {...register("contact_address", {
                        minLength: {
                          value: 3,
                          message:
                            "Contact address must be at least 3 characters.",
                        },
                      })}
                    ></input>
                    {errors.contact_address && (
                      <div class="invalid-feedback d-block">
                        {errors.contact_address.message}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                    <label>
                      Country
                      {/* <span className="text-danger">*</span> */}
                    </label>

                    <Select
                      {...register("country_id", {
                        // required: { value: true, message: "Select a country." },
                      })}
                      options={context?.countryList?.map((item) => ({
                        label: item.name,
                        value: item.id,
                      }))}
                      value={selectedCountry}
                      onChange={(selected) => {
                        setSelectedCountry(selected);
                        getAllStateByCountryId(selected ? selected.value : "");
                        setValue("country_id", selected ? selected.value : "");
                        trigger("country_id");

                        setSelSt(null);
                        setSelCt(null);
                        setValue("state_id", "");
                        trigger("state_id");

                        setValue("city_id", "");
                        trigger("city_id");
                      }}
                      placeholder="Select a country"
                      className={`selectpicker p-0 ${
                        errors.country_id && "is-invalid bdr-red"
                      }`}
                      classNamePrefix="react-select"
                      isSearchable={false}
                    />

                    {errors.country_id && (
                      <div class="invalid-feedback d-block">
                        {errors.country_id.message}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                    <label>
                      State
                      {/* <span className="text-danger">*</span> */}
                    </label>

                    <Select
                      {...register("state_id", {
                        // required: { value: true, message: "Select a state." },
                      })}
                      options={stateList?.map((item) => ({
                        label: item.name,
                        value: item.id,
                      }))}
                      value={selSt}
                      onChange={(selected) => {
                        setSelSt(selected);
                        getAllCityByStateAndCountryId(
                          selected ? selected.value : ""
                        );
                        setValue("state_id", selected ? selected.value : "");
                        trigger("state_id");

                        setSelSt(selected);
                        setSelCt(null);

                        setValue("city_id", "");
                        trigger("city_id");
                      }}
                      placeholder="Select a state"
                      className={`selectpicker p-0 ${
                        errors.state_id && "is-invalid bdr-red"
                      }`}
                      classNamePrefix="react-select"
                    />
                    {errors.state_id && (
                      <div class="invalid-feedback d-block">
                        {errors.state_id.message}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                    <label>
                      City
                      {/* <span className="text-danger">*</span> */}
                    </label>

                    <Select
                      {...register("city_id", {
                        // required: { value: true, message: "Select a city." },
                      })}
                      options={cityList?.map((item) => ({
                        label: item.name,
                        value: item.id,
                      }))}
                      value={selCt}
                      onChange={(selected) => {
                        setValue("city_id", selected ? selected.value : "");
                        trigger("city_id");

                        setSelCt(selected);
                      }}
                      placeholder="Select a city"
                      className={`selectpicker p-0 ${
                        errors.city_id && "is-invalid bdr-red"
                      }`}
                      classNamePrefix="react-select"
                    />
                    {errors.city_id && (
                      <div class="invalid-feedback d-block">
                        {errors.city_id.message}
                      </div>
                    )}
                  </div>

                  {ads_id == 1 && (
                    <>
                      {subSubCatList?.length > 0 && (
                        <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                          <label>Make</label>

                          <Select
                            {...register("Make", {
                              // required: {
                              //   value: true,
                              //   message: "Select make.",
                              // },
                            })}
                            options={subSubCatList
                              ?.filter((item) => item.type === "Make")
                              ?.map((item) => ({
                                label: item.name,
                                value: item.name,
                              }))}
                            onChange={(selected) => {
                              setValue("Make", selected ? selected.value : "");
                              trigger("Make");
                            }}
                            placeholder="Select make"
                            className={`selectpicker p-0 ${
                              errors.Make && "is-invalid bdr-red"
                            }`}
                            classNamePrefix="react-select"
                          />
                          {errors.Make && (
                            <div class="invalid-feedback d-block">
                              {errors.Make.message}
                            </div>
                          )}
                        </div>
                      )}
                      {subSubCatList?.length > 0 && (
                        <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                          <label>Color</label>

                          <Select
                            {...register("Color", {
                              // required: {
                              //   value: true,
                              //   message: "Select color.",
                              // },
                            })}
                            options={subSubCatList
                              ?.filter((item) => item.type === "Color")
                              ?.map((item) => ({
                                label: item.name,
                                value: item.name,
                              }))}
                            onChange={(selected) => {
                              setValue("Color", selected ? selected.value : "");
                              trigger("Color");
                            }}
                            placeholder="Select color"
                            className={`selectpicker p-0 ${
                              errors.Color && "is-invalid bdr-red"
                            }`}
                            classNamePrefix="react-select"
                          />
                          {errors.Color && (
                            <div class="invalid-feedback d-block">
                              {errors.Color.message}
                            </div>
                          )}
                        </div>
                      )}
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Models</label>
                        <input
                          className={`form-control bg-transparent ${
                            errors.Models && "is-invalid"
                          }`}
                          placeholder="Models"
                          {...register("Models", {
                            // required: {
                            //   value: true,
                            //   message: "Models is required.",
                            // },
                          })}
                        />
                        {errors.Models && (
                          <div class="invalid-feedback">
                            {errors.Models.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Type</label>

                        <Select
                          {...register("action_type", {
                            // required: { value: true, message: "Select type." },
                          })}
                          options={actionTypeOption?.map((item) => ({
                            label: item.name,
                            value: item.name,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "action_type",
                              selected ? selected.value : ""
                            );
                            trigger("action_type");
                          }}
                          placeholder="Select type"
                          className={`selectpicker p-0 ${
                            errors.action_type && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.action_type && (
                          <div class="invalid-feedback d-block">
                            {errors.action_type.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Select Condition</label>

                        <Select
                          {...register("Condition", {
                            // required: {
                            //   value: true,
                            //   message: "Select condition.",
                            // },
                          })}
                          options={conditionOption?.map((item) => ({
                            label: item.name,
                            value: item.name,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "Condition",
                              selected ? selected.value : ""
                            );
                            trigger("Condition");
                          }}
                          placeholder="Select condition"
                          className={`selectpicker p-0 ${
                            errors.Condition && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.Condition && (
                          <div class="invalid-feedback d-block">
                            {errors.Condition.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Select Transmission</label>

                        <Select
                          {...register("Transmission", {
                            // required: {
                            //   value: true,
                            //   message: "Select transmission.",
                            // },
                          })}
                          options={transmissionOption?.map((item) => ({
                            label: item.name,
                            value: item.name,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "Transmission",
                              selected ? selected.value : ""
                            );
                            trigger("Transmission");
                          }}
                          placeholder="Select transmission"
                          className={`selectpicker p-0 ${
                            errors.Transmission && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.Transmission && (
                          <div class="invalid-feedback d-block">
                            {errors.Transmission.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Select Cylinder</label>

                        <Select
                          {...register("cylinder", {
                            // required: {
                            //   value: true,
                            //   message: "Select cylinder.",
                            // },
                          })}
                          options={cylinderOption?.map((item) => ({
                            label: item.name,
                            value: item.name,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "cylinder",
                              selected ? selected.value : ""
                            );
                            trigger("cylinder");
                          }}
                          placeholder="Select cylinder"
                          className={`selectpicker p-0 ${
                            errors.cylinder && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.cylinder && (
                          <div class="invalid-feedback d-block">
                            {errors.cylinder.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Select Auto Type</label>

                        <Select
                          {...register("Type", {
                            // required: {
                            //   value: true,
                            //   message: "Select auto type.",
                            // },
                          })}
                          options={autoOption?.map((item) => ({
                            label: item.name,
                            value: item.name,
                          }))}
                          onChange={(selected) => {
                            setValue("Type", selected ? selected.value : "");
                            trigger("Type");
                          }}
                          placeholder="Select auto type"
                          className={`selectpicker p-0 ${
                            errors.Type && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.Type && (
                          <div class="invalid-feedback d-block">
                            {errors.Type.message}
                          </div>
                        )}
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Select Drive Train</label>

                        <Select
                          {...register("DriveTrain", {
                            // required: {
                            //   value: true,
                            //   message: "Select drive train.",
                            // },
                          })}
                          options={driveOption?.map((item) => ({
                            label: item.name,
                            value: item.name,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "DriveTrain",
                              selected ? selected.value : ""
                            );
                            trigger("DriveTrain");
                          }}
                          placeholder="Select drive train"
                          className={`selectpicker p-0 ${
                            errors.DriveTrain && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.DriveTrain && (
                          <div class="invalid-feedback d-block">
                            {errors.DriveTrain.message}
                          </div>
                        )}
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Select Year</label>

                        <Select
                          {...register("Year", {
                            // required: { value: true, message: "Select year." },
                          })}
                          options={years?.map((item) => ({
                            label: item.name,
                            value: item.name,
                          }))}
                          onChange={(selected) => {
                            setValue("Year", selected ? selected.value : "");
                            trigger("Year");
                          }}
                          placeholder="Select year"
                          maxLength={4}
                          className={`selectpicker p-0 ${
                            errors.Year && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.Year && (
                          <div class="invalid-feedback d-block">
                            {errors.Year.message}
                          </div>
                        )}
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Vin Number</label>
                        <input
                          className={`form-control bg-transparent ${
                            errors.VinNumber && "is-invalid"
                          }`}
                          placeholder="Vin Number"
                          type="number"
                          min="0"
                          onInput={(e) => {
                            if (e.target.value.length > 20) {
                              e.target.value = e.target.value.slice(0, 20);
                            }
                          }}
                          {...register("VinNumber", {
                            // required: {
                            //   value: true,
                            //   message: "Vin number is required.",
                            // },
                          })}
                        />
                        {errors.VinNumber && (
                          <div class="invalid-feedback">
                            {errors.VinNumber.message}
                          </div>
                        )}
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>ODO Meter Reading</label>
                        <input
                          className={`form-control bg-transparent ${
                            errors.ODO_Meter_Reading && "is-invalid"
                          }`}
                          placeholder="ODO Meter Reading"
                          type="number"
                          min="0"
                          onInput={(e) => {
                            if (e.target.value.length > 10) {
                              e.target.value = e.target.value.slice(0, 10);
                            }
                          }}
                          {...register("ODO_Meter_Reading", {
                            // required: {
                            //   value: true,
                            //   message: "ODO meter reading is required.",
                            // },
                          })}
                        />
                        {errors.ODO_Meter_Reading && (
                          <div class="invalid-feedback">
                            {errors.ODO_Meter_Reading.message}
                          </div>
                        )}
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Price</label>
                        <input
                          className={`form-control bg-transparent ${
                            errors.price && "is-invalid"
                          }`}
                          placeholder="Price"
                          type="number"
                          step="any"
                          min="0"
                          onInput={(e) => {
                            if (e.target.value.length > 10) {
                              e.target.value = e.target.value.slice(0, 10);
                            }
                          }}
                          {...register("price", {
                            // required: {
                            //   value: true,
                            //   message: "Rent is required.",
                            // },
                          })}
                        />
                        {errors.price && (
                          <div class="invalid-feedback">
                            {errors.price.message}
                          </div>
                        )}
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Current MPG (Miles Per Gallon)</label>

                        <Select
                          {...register("MPG", {
                            // required: { value: true, message: "Select MPG." },
                          })}
                          options={MPGOption?.map((item) => ({
                            label: item.name,
                            value: item.name,
                          }))}
                          onChange={(selected) => {
                            setValue("MPG", selected ? selected.value : "");
                            trigger("MPG");
                          }}
                          placeholder="Select MPG"
                          className={`selectpicker p-0 ${
                            errors.MPG && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.MPG && (
                          <div class="invalid-feedback d-block">
                            {errors.MPG.message}
                          </div>
                        )}
                      </div>

                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Currency</label>

                        <Select
                          {...register("currency", {
                            // required: {
                            //   value: true,
                            //   message: "Select currency.",
                            // },
                          })}
                          options={currencyOption?.map((item) => ({
                            label: item.name,
                            value: item.name,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "currency",
                              selected ? selected.value : ""
                            );
                            trigger("currency");
                          }}
                          placeholder="Select currency"
                          className={`selectpicker p-0 ${
                            errors.currency && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.currency && (
                          <div class="invalid-feedback d-block">
                            {errors.currency.message}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  {ads_id == 8 && (
                    <>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Emplyoment type</label>

                        <Select
                          {...register("Employment_Type", {
                            // required: {
                            //   value: true,
                            //   message: "Select employment type.",
                            // },
                          })}
                          options={employmentType?.map((item) => ({
                            label: item.name,
                            value: item.id,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "Employment_Type",
                              selected ? selected.value : ""
                            );
                            trigger("Employment_Type");
                          }}
                          placeholder="Select employment type"
                          className={`selectpicker p-0 ${
                            errors.Employment_Type && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.Employment_Type && (
                          <div class="invalid-feedback d-block">
                            {errors.Employment_Type.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Job Reference Id</label>
                        <input
                          className={`form-control bg-transparent ${
                            errors.Job_Reference_Id && "is-invalid"
                          }`}
                          placeholder="Job Reference Id"
                          type="number"
                          min="0"
                          onInput={(e) => {
                            if (e.target.value.length > 10) {
                              e.target.value = e.target.value.slice(0, 10);
                            }
                          }}
                          {...register("Job_Reference_Id", {
                            // required: {
                            //   value: true,
                            //   message: "Job reference id is required.",
                            // },
                            minLength: {
                              value: 3,
                              message:
                                "Job reference id must be at least 3 digit.",
                            },
                          })}
                        />
                        {errors.Job_Reference_Id && (
                          <div class="invalid-feedback">
                            {errors.Job_Reference_Id.message}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  {ads_id == 9 && (
                    <>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Gender Preference</label>

                        <Select
                          {...register("Gender_Preference", {
                            // required: {
                            //   value: true,
                            //   message: "Select gender preference.",
                            // },
                          })}
                          options={genderType?.map((item) => ({
                            label: item.name,
                            value: item.id,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "Gender_Preference",
                              selected ? selected.value : ""
                            );
                            trigger("Gender_Preference");
                          }}
                          placeholder="Select gender preference"
                          className={`selectpicker p-0 ${
                            errors.Gender_Preference && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.Gender_Preference && (
                          <div class="invalid-feedback d-block">
                            {errors.Gender_Preference.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>Rent</label>
                        <input
                          className={`form-control bg-transparent ${
                            errors.price && "is-invalid"
                          }`}
                          placeholder="Rent"
                          type="number"
                          step="any"
                          min="0"
                          onInput={(e) => {
                            if (e.target.value.length > 10) {
                              e.target.value = e.target.value.slice(0, 10);
                            }
                          }}
                          {...register("price", {
                            // required: {
                            //   value: true,
                            //   message: "Rent is required.",
                            // },
                          })}
                        />
                        {errors.price && (
                          <div class="invalid-feedback">
                            {errors.price.message}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  {ads_id == 5 && (
                    <>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>
                          Build Year
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <input
                          className={`form-control bg-transparent ${
                            errors.Built_Year && "is-invalid"
                          }`}
                          placeholder="Build year"
                          maxLength={4}
                          type="text"
                          min="0"
                          {...register("Built_Year", {
                            // required: {
                            //   value: true,
                            //   message: "Build year is required.",
                            // },
                            pattern: {
                              value: /^\d{4}$/,
                              message: "Enter a valid 4-digit year.",
                            },
                            min: {
                              value: 1990,
                              message: "Built year must be at least 1900.",
                            },
                            max: {
                              value: new Date().getFullYear(),
                              message: "Built year can't be in the future.",
                            },
                          })}
                        />
                        {errors.Built_Year && (
                          <div class="invalid-feedback">
                            {errors.Built_Year.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>
                          Property Price
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <input
                          className={`form-control bg-transparent ${
                            errors.Property_Price && "is-invalid"
                          }`}
                          placeholder="Property Price"
                          type="number"
                          step="any"
                          min="0"
                          onInput={(e) => {
                            if (e.target.value.length > 10) {
                              e.target.value = e.target.value.slice(0, 10);
                            }
                          }}
                          {...register("Property_Price", {
                            // required: {
                            //   value: true,
                            //   message: "Property price is required.",
                            // },
                          })}
                        />
                        {errors.Property_Price && (
                          <div class="invalid-feedback">
                            {errors.Property_Price.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>
                          Square Feet
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <input
                          className={`form-control bg-transparent ${
                            errors.Square_Feet && "is-invalid"
                          }`}
                          placeholder="Square Feet"
                          type="number"
                          min="0"
                          onInput={(e) => {
                            if (e.target.value.length > 6) {
                              e.target.value = e.target.value.slice(0, 6);
                            }
                          }}
                          {...register("Square_Feet", {
                            // required: {
                            //   value: true,
                            //   message: "Square feet is required.",
                            // },
                          })}
                        />
                        {errors.Square_Feet && (
                          <div class="invalid-feedback">
                            {errors.Square_Feet.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>No of Bedrooms</label>

                        <Select
                          {...register("No_of_Bedrooms", {
                            // required: {
                            //   value: true,
                            //   message: "Select no of bedrooms.",
                            // },
                          })}
                          options={noOfBedrooms?.map((item) => ({
                            label: item.name,
                            value: item.id,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "No_of_Bedrooms",
                              selected ? selected.value : ""
                            );
                            trigger("No_of_Bedrooms");
                          }}
                          placeholder="Select no of bedrooms"
                          className={`selectpicker p-0 ${
                            errors.No_of_Bedrooms && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.No_of_Bedrooms && (
                          <div class="invalid-feedback d-block">
                            {errors.No_of_Bedrooms.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>No of Bathrooms</label>

                        <Select
                          {...register("No_of_Bathrooms", {
                            // required: {
                            //   value: true,
                            //   message: "Select no of bathrooms.",
                            // },
                          })}
                          options={noOfBathrooms?.map((item) => ({
                            label: item.name,
                            value: item.id,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "No_of_Bathrooms",
                              selected ? selected.value : ""
                            );
                            trigger("No_of_Bathrooms");
                          }}
                          placeholder="Select no of bathrooms"
                          className={`selectpicker p-0 ${
                            errors.No_of_Bathrooms && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.No_of_Bathrooms && (
                          <div class="invalid-feedback d-block">
                            {errors.No_of_Bathrooms.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>No of Other Rooms</label>

                        <Select
                          {...register("No_of_Other_Rooms", {
                            // required: {
                            //   value: true,
                            //   message: "Select no of other rooms.",
                            // },
                          })}
                          options={noOfOtherrooms?.map((item) => ({
                            label: item.name,
                            value: item.id,
                          }))}
                          onChange={(selected) => {
                            setValue(
                              "No_of_Other_Rooms",
                              selected ? selected.value : ""
                            );
                            trigger("No_of_Other_Rooms");
                          }}
                          placeholder="Select no of other rooms"
                          className={`selectpicker p-0 ${
                            errors.No_of_Other_Rooms && "is-invalid bdr-red"
                          }`}
                          classNamePrefix="react-select"
                        />
                        {errors.No_of_Other_Rooms && (
                          <div class="invalid-feedback d-block">
                            {errors.No_of_Other_Rooms.message}
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                        <label>
                          Next Open House Date{" "}
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="custom-datepicker-wrapper">
                          <DatePicker
                            className={`form-control bg-transparent dp ${
                              errors.Next_open_house_date && "is-invalid"
                            }`}
                            clearIcon={false}
                            monthPlaceholder="MM"
                            dayPlaceholder="DD"
                            yearPlaceholder="YYYY"
                            onChange={(date) => {
                              setNextOpenDate(date);
                              setValue("Next_open_house_date", date, {
                                shouldValidate: true,
                              });
                            }}
                            minDate={new Date()}
                            value={nextOpenDate}
                          />
                        </div>
                        <input
                          type="hidden"
                          {...register("Next_open_house_date", {
                            // required: "Next open house date is required.",
                          })}
                        />
                        {errors.Next_open_house_date && (
                          <div class="invalid-feedback d-block">
                            {errors.Next_open_house_date.message}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  {(ads_id == 5 ||
                    ads_id == 3 ||
                    ads_id == 8 ||
                    ads_id == 9 ||
                    ads_id == 10 ||
                    ads_id == 1) && (
                    <div className="col-sm-6 col-md-4 col-lg-3 mb-2">
                      <label>URL</label>
                      <input
                        className={`form-control bg-transparent ${
                          errors.url && "is-invalid"
                        }`}
                        placeholder="URL"
                        {...register("url", {
                          pattern: {
                            value:
                              /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
                            message: "URL is invalid.",
                          },
                        })}
                      />
                      {errors.url && (
                        <div class="invalid-feedback">{errors.url.message}</div>
                      )}
                    </div>
                  )}

                  <div className="col-12 mb-3">
                    <label className="cb-container mb-0">
                      <input
                        type="checkbox"
                        name="agree"
                        checked={useMap}
                        onChange={(e) => {
                          setUseMap(e.target.checked);
                        }}
                      />

                      <span className="checkmark"></span>
                    </label>
                    <span className="text-small ms-4 ps-2">
                      Use this on map
                    </span>
                  </div>
                  <div className="col-lg-6">
                    <div class="mb-2 bdr-col-1">
                      <label class="form-label font12">Image</label>
                      <Dropzone
                        className="dropzone"
                        onFileDrop={onFileDrop}
                        setError={setError}
                        clearErrors={clearErrors}
                        uploadFile="image"
                        fieldName="file"
                        fileName={file}
                      />
                      {file && <p>File Name: {file.name}</p>}
                      {errors.file && (
                        <div class="invalid-feedback d-block">
                          {errors.file.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div class="mb-2">
                      <label class="form-label font12">Description</label>
                      <span className="text-danger">*</span>
                      <textarea
                        // class={`form-control ${
                        //   errors.description && "is-invalid"
                        // }`}
                        className={`form-control bg-transparent  ${
                          errors.description && "is-invalid"
                        }`}
                        style={{
                          minHeight: "200px",
                          borderRadius: "10px",
                          border: "2px solid rgb(224, 230, 247)",
                        }}
                        rows="5"
                        placeholder="Description"
                        maxLength={1024}
                        {...register("description", {
                          required: {
                            value: true,
                            message: "Description is required",
                          },
                        })}
                      ></textarea>
                      {errors.description && (
                        <div class="invalid-feedback">
                          {errors.description.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="text-end mt-3">
                  {ads_type == "premium" ? (
                    showPaypal ? (
                      <PayPalScriptProvider
                        options={{
                          clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
                          currency: "USD", // Adjust currency as needed
                        }}
                      >
                        <PayPalButtons
                          createOrder={createOrder}
                          onApprove={onApprove}
                          onError={onError}
                          style={{
                            color: "gold",
                            shape: "rect",
                            label: "pay",
                          }}
                          // Other button customization options
                        />
                      </PayPalScriptProvider>
                    ) : (
                      <a
                        href="#!"
                        class="btn btn-warning font13 d-inline-flex align-items-center"
                        onClick={checkIfFormValid}
                      >
                        Pay with Paypal
                      </a>
                    )
                  ) : (
                    <button
                      class="btn btn-warning font13 d-inline-flex align-items-center"
                      type="submit"
                    >
                      Save Ad<i className="fi fi-rr-arrow-small-right ms-2"></i>
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div class="col-lg-12">
          <div class="card card-forum ">
            <div class="card-body bg-white p-1">
              <div class="text-center text-danger p-3">
                Please{" "}
                <a
                  href="#!"
                  className=" fw-bold"
                  data-bs-toggle="modal"
                  data-bs-target="#loginModal"
                >
                  Login
                </a>{" "}
                to view details.
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateAds;
